module.exports = __webpack_public_path__ + "img/Frame3.dac5d6df.png";